import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { activateAccount } from "../features/auth/authThunks.js";
import { clearActivationState } from "../features/auth/authSlice.js";

import "../styles/password/activate-account.css";

const ActivateAccount = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const { activationLoading, activationError, activationSuccessMessage } =
    useSelector((state) => state.auth);

  const [password, setPassword] = useState("");

  const token = useMemo(() => {
    const params = new URLSearchParams(location.search);
    return (params.get("token") || "").trim();
  }, [location.search]);

  const needsPassword = (activationError || "")
    .toLowerCase()
    .includes("definir una contraseña");

  useEffect(() => {
    dispatch(clearActivationState());

    if (!token) return;

    dispatch(activateAccount({ token }));
  }, [dispatch, token]);

  const handleActivateWithPassword = async (event) => {
    event.preventDefault();
    await dispatch(activateAccount({ token, password }));
  };

  return (
    <div className="activation-page">
      <div className="activation-card">
        <div className="activation-header">
          <h1 className="activation-title">Activar cuenta</h1>
          <p className="activation-subtitle">
            Estás a un paso de entrar al portal.
          </p>
        </div>

        {!token && (
          <div className="activation-message activation-message--info">
            Falta el token. Abre el enlace que te llegó por email.
          </div>
        )}

        {token && activationLoading && (
          <div className="activation-message activation-message--info">
            Activando…
          </div>
        )}

        {token && activationSuccessMessage && (
          <>
            <div className="activation-message activation-message--success">
              {activationSuccessMessage}
            </div>

            <div className="activation-actions">
              <button
                type="button"
                className="activation-btn activation-btn--primary"
                onClick={() => navigate("/log-in")}
              >
                Ir a iniciar sesión
              </button>
            </div>
          </>
        )}

        {token && activationError && !needsPassword && (
          <>
            <div className="activation-message activation-message--error">
              {activationError}
            </div>

            <div className="activation-actions">
              <button
                type="button"
                className="activation-btn activation-btn--primary"
                onClick={() => navigate("/log-in")}
              >
                Ir a iniciar sesión
              </button>
            </div>
          </>
        )}

        {token && activationError && needsPassword && (
          <form className="activation-form" onSubmit={handleActivateWithPassword}>
            <div className="activation-message activation-message--warning">
              {activationError}
            </div>

            <div className="activation-field">
              <label htmlFor="password">Nueva contraseña</label>
              <input
                id="password"
                type="password"
                value={password}
                onChange={(event) => setPassword(event.target.value)}
                required
                className="activation-input"
                autoComplete="new-password"
              />
              <div className="activation-hint">
                Usa una contraseña segura (mínimo 8 caracteres).
              </div>
            </div>

            <div className="activation-actions activation-actions--form">
              <button
                type="submit"
                disabled={activationLoading}
                className="activation-btn activation-btn--primary"
              >
                {activationLoading ? "Activando…" : "Activar cuenta"}
              </button>

              <button
                type="button"
                className="activation-btn activation-btn--ghost"
                onClick={() => navigate("/log-in")}
                disabled={activationLoading}
              >
                Volver al login
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
};

export default ActivateAccount;